var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIngresos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168.954,
    height: 118.636,
    viewBox: "0 0 168.954 118.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;}.c{fill:#909090;}.d{fill:#28a745;}.e{fill:#7b7b7b;font-size:15px;font-family:Barlow-Medium, Barlow;font-weight:500;letter-spacing:0.008em;}.f{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 168.954,
    height: 118.636,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15102 -8753)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 15102, 8753)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.869-1,146.085.623a4.869,4.869,0,0,1,4.87,4.869V94.767a4.869,4.869,0,0,1-4.87,4.869H4.869A4.869,4.869,0,0,1,0,94.767V5.493C0,2.8,2.18-1,4.869-1Z",
    transform: "translate(9 7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15189.724 8830.419)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H17.043V27.595H0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 71,
    height: 8,
    rx: 4,
    transform: "translate(15182 8770.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(15205 8785.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 130,
    height: 7,
    rx: 3.5,
    transform: "translate(15123 8799.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 47,
    height: 3,
    rx: 1.5,
    transform: "translate(15123 8812.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(15174 8812.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 28,
    height: 3,
    rx: 1.5,
    transform: "translate(15225 8812.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 25,
    height: 3,
    rx: 1.5,
    transform: "translate(15123 8822.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 26,
    height: 3,
    rx: 1.5,
    transform: "translate(15174 8822.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 27,
    height: 3,
    rx: 1.5,
    transform: "translate(15226 8822.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 27,
    height: 4,
    rx: 2,
    transform: "translate(15226 8831.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 46,
    height: 6,
    rx: 3,
    transform: "translate(15207 8843.637)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(15123 8780.637)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RECIBO")), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M9.762,7.595c-1.426-.343-1.885-.7-1.885-1.251,0-.634.634-1.076,1.7-1.076,1.118,0,1.533.494,1.57,1.221h1.388a2.372,2.372,0,0,0-2.016-2.216V3H8.632V4.256c-1.219.244-2.2.977-2.2,2.1,0,1.344,1.2,2.012,2.952,2.4,1.57.349,1.885.861,1.885,1.4,0,.4-.308,1.041-1.7,1.041-1.294,0-1.8-.535-1.872-1.221H6.32a2.531,2.531,0,0,0,2.312,2.228V13.47h1.885V12.219c1.225-.215,2.2-.872,2.2-2.065C12.715,8.5,11.188,7.938,9.762,7.595Z",
    transform: "translate(15190.399 8837.646)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngresos);
export default __webpack_public_path__ + "static/media/ingresos.0b5cd74ce5a63e758f144117b981d61f.svg";
export { ForwardRef as ReactComponent };